import Component from '@ember/component';
import { computed, get, set, setProperties } from '@ember/object';
import { run } from '@ember/runloop';
import { service } from '@ember/service';
import { htmlSafe } from '@ember/template';
import logger from 'donor-elf-web/lib/logger';
const { FormData, XMLHttpRequest } = window;

/*
  attrs
  - file - the file object from a <input type='file'> element

  events
  - onUploadComplete(s3Upload)
    - fires when the upload to AWS is complete
  - onUploadError(s3Upload)
  - onUploadCancelled(s3Upload)
*/
export default Component.extend({
  fundsService: service(),
  store: service(),

  s3Upload: null,

  file: null,

  uploading: false,
  completed: false,
  percentUploaded: 5,
  progressBarStyle: null,

  didInsertElement() {
    this._super(...arguments);
    this.upload();
  },

  upload() {
    if (this.file == null) {
      logger.error('The file attribute on s3-upload-progress was not set');
      return;
    }
    set(this, 'uploading', true);

    return this.createS3UploadRecord().then(() => {
      return this.uploadToS3();
    });
  },

  createS3UploadRecord() {
    return this.fundsService.confirmValidFundToken().then(() => {
      let s3Upload = this.store.createRecord('s3-upload', {
        fileName: get(this, 'file.name'),
      });
      return s3Upload.save().then(() => {
        set(this, 's3Upload', s3Upload);
        return s3Upload;
      });
    });
  },

  uploadToS3() {
    set(this, 'uploading', true);
    let formData = new FormData();
    formData.append('key', get(this, 's3Upload.key'));
    formData.append('AWSAccessKeyId', get(this, 's3Upload.accessKey'));
    formData.append('acl', 'private');
    formData.append('policy', get(this, 's3Upload.policy'));
    formData.append('signature', get(this, 's3Upload.signature'));
    formData.append('success_action_status', '201');
    formData.append('file', this.file);

    let xhr = new XMLHttpRequest();
    xhr.upload.addEventListener('progress', this.xhrProgress.bind(this), false);
    xhr.addEventListener('load', this.xhrComplete.bind(this), false);
    xhr.addEventListener('error', this.xhrError.bind(this), false);
    xhr.addEventListener('abort', this.xhrCancelled.bind(this), false);
    xhr.open('POST', this.actionUrl, true);
    xhr.send(formData);
  },

  xhrProgress(e) {
    run(() => {
      if (e.lengthComputable) {
        set(this, 'percentUploaded', Math.round((e.loaded * 100) / e.total));
        this.updateProgressBar();
      }
    });
  },

  xhrComplete() {
    run(() => {
      setProperties(this, {
        percentUploaded: 100,
        completed: true,
      });
      this.updateProgressBar();
      this.onUploadComplete(this.s3Upload);
    });
  },

  xhrError(e) {
    run(() => {
      let onUploadError = this.onUploadError;
      if (onUploadError) {
        onUploadError(this.s3Upload, e);
      }
    });
  },

  xhrCancelled() {
    run(() => {
      let onUploadCancelled = this.onUploadCancelled;
      if (onUploadCancelled) {
        onUploadCancelled(this.s3Upload);
      }
    });
  },

  updateProgressBar() {
    set(this, 'progressBarStyle', htmlSafe(`width: ${this.percentUploaded}%`));
  },

  actionUrl: computed('s3Upload.bucket', function () {
    return `https://${get(this, 's3Upload.bucket')}.s3.amazonaws.com`;
  }),
});
